const menu = [
    {   path: "/",
        tag: "Inicio",
        name: "home"
    },
]
const trail = {
    static: [
        {
            path: "http://www.igp.gob.pe/",
            tag: "Portal IGP",
            name: "portal"
        },
        {
            path: "https://www.igp.gob.pe/informacion-institucional/",
            tag: "Información Institucional",
            name: "root"
        },        
    ],
    dynamic: [
        {
            path: "/",
            tag: "Presupuesto por Resultados"
        },
    ]
}

function getTrail () {
    return trail;
}

function getMenu () {
    return menu;
}

export {
    getMenu,
    getTrail
}